import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { X } from "lucide-react";

const LightboxCtx = createContext({ open: () => {} });
export const useLightbox = () => useContext(LightboxCtx);

export default function LightboxProvider({ children }) {
  const [item, setItem] = useState(null); // { src, alt }

  const open = useCallback((src, alt = "") => {
    if (src) setItem({ src, alt });
  }, []);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") setItem(null);
    };
    if (item) {
      window.addEventListener("keydown", onKey);
      return () => window.removeEventListener("keydown", onKey);
    }
  }, [item]);

  return (
    <LightboxCtx.Provider value={{ open }}>
      {children}
      <Dialog open={!!item} onOpenChange={(o) => !o && setItem(null)}>
        <DialogContent
          data-testid="lightbox-modal"
          className="bg-black/95 border-white/10 text-white max-w-[95vw] sm:max-w-5xl p-2 sm:p-4 [&>button]:hidden"
        >
          {item && (
            <div className="relative">
              <button
                type="button"
                onClick={() => setItem(null)}
                data-testid="lightbox-close"
                aria-label="Close"
                className="absolute -top-2 -right-2 sm:top-2 sm:right-2 z-10 bg-black border border-white/20 hover:border-brand-blue/60 hover:bg-brand-blue/20 p-2 rounded-full transition-colors"
              >
                <X size={16} />
              </button>
              <img
                src={item.src}
                alt={item.alt}
                data-testid="lightbox-image"
                className="w-full max-h-[85vh] object-contain rounded-sm"
              />
              {item.alt && (
                <div className="mt-2 text-center font-mono-accent text-[11px] uppercase tracking-[0.22em] text-zinc-400">
                  {item.alt}
                </div>
              )}
            </div>
          )}
        </DialogContent>
      </Dialog>
    </LightboxCtx.Provider>
  );
}
